export const callBlockForm = {
  table: "v_call_block",
  required: ["call_block_direction", "call_block_action"],
  sections: {
    "Basic Info": [
      "call_block_direction",
      "extension",
      "call_block_name",
      "call_block_number",
      "call_block_action",
      //"domain",
      "call_block_enabled",
      "call_block_description",
    ],
  },

  types: {
    call_block_enabled: "boolean",
    call_block_direction: "select",
    call_block_action: "select",
    extension: "select",
    domain: "select",
  },

  options: {
    call_block_direction: ["Inbound", "Outbound"],
    call_block_action: ["Reject", "Busy", "Hold", "none"],
  },
};
